import { redirect } from "react-router";
import { authClient, hasAppRole } from "../lib/auth";

/**
 * Loader for the admin and teacher areas: checks the session before any page in
 * them renders or downloads, and redirects signed-out visitors to login.
 * The session is handed to the shared better-auth store, so useAuth() already has
 * the user on first render and doesn't fetch it again.
 */
export async function requireAuth(): Promise<null> {
  const { data: session } = await authClient.getSession().catch(() => ({ data: null }));
  authClient.hydrateSession(session ?? null);
  if (!hasAppRole(session?.user)) throw redirect("/auth/login");
  return null;
}

/**
 * Route props for a protected area. The check runs when the area is entered, not on
 * every navigation or filter change inside it; ProtectedRoute and the HTTP client's
 * session-expiry event cover a session that ends mid-visit.
 */
export const protectedAreaProps = {
  loader: requireAuth,
  shouldRevalidate: () => false,
} as const;
